import { supabase } from "@/integrations/supabase/client";
import type { CouponBrand } from "@/components/coupons/CouponBrandCard";
import { getHomeOffers } from "@/lib/homeOffers.functions";

export const homeOffersQueryOptions = () => ({
  queryKey: ["home-offers"] as const,
  staleTime: 10 * 60 * 1000,
  queryFn: () => getHomeOffers(),
});

export type HomeCoupon = CouponBrand & { brand: CouponBrand["brand"] & { category: { slug: string; name: string } | null } };

/** Melhor cupom ativo por marca (exclusivos primeiro, depois mais usados). */
export const homeCouponsQueryOptions = () => ({
  queryKey: ["home-coupons"] as const,
  staleTime: 5 * 60 * 1000,
  queryFn: async (): Promise<HomeCoupon[]> => {
    const iso = new Date().toISOString();
    const { data, error } = await supabase
      .from("coupons")
      .select("id,title,code,discount_type,discount_value,expires_at,uses_count,is_exclusive,updated_at,brand:brands!inner(name,slug,logo_url,donation_percentage,commission_type,is_active,network_paused,merged_into_id,category:categories(slug,name))")
      .eq("type", "code")
      .eq("is_active", true)
      .not("code", "is", null)
      .neq("code", "")
      .eq("brand.is_active", true)
      .eq("brand.network_paused", false)
      .is("brand.merged_into_id", null)
      .or(`expires_at.is.null,expires_at.gte.${iso}`)
      .order("is_exclusive", { ascending: false })
      .order("uses_count", { ascending: false, nullsFirst: false })
      .limit(1000);
    if (error) throw error;
    const best = new Map<string, HomeCoupon>();
    for (const c of (data ?? []) as unknown as HomeCoupon[]) {
      if (!best.has(c.brand.slug)) best.set(c.brand.slug, c);
    }
    // Sem campos sensíveis (código) no cache serializado no HTML.
    return [...best.values()].map(({ ...c }) => {
      delete (c as { code?: string }).code;
      return c;
    });
  },
});

export type HomePost = { id: string; slug: string; title: string; excerpt: string | null; featured_image_url: string | null; published_at: string | null };

export const homeBlogQueryOptions = () => ({
  queryKey: ["home-blog"] as const,
  staleTime: 10 * 60 * 1000,
  queryFn: async (): Promise<HomePost[]> => {
    const { data, error } = await supabase
      .from("blog_posts")
      .select("id,slug,title,excerpt,featured_image_url,published_at")
      .eq("status", "published")
      .order("published_at", { ascending: false })
      .limit(3);
    if (error) throw error;
    return (data ?? []) as HomePost[];
  },
});

